const HEADER_SIZE = 118;
const FOOTER_SIZE = 90;

export {HEADER_SIZE, FOOTER_SIZE};
